(function () {
  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    return `$${amount.toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  function parseVariants(selector) {
    try {
      return JSON.parse(selector.dataset.productVariants || "[]");
    } catch (error) {
      return [];
    }
  }

  function selectedOptions(selector) {
    return Array.from(selector.querySelectorAll("[data-option-position]"))
      .filter((element) => element.tagName === "SELECT")
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((select) => select.value);
  }

  function variantMatches(variant, options) {
    return options.every((value, index) => variant[`option${index + 1}`] === value);
  }

  function imageUrl(variant) {
    if (!variant || !variant.featured_image) return "";
    return variant.featured_image.src || "";
  }

  function toDisplayTitle(text) {
    const cleaned = String(text || "")
      .replace(/\s+-\s+/g, " ")
      .replace(/\bFA[-\s]?\d+\b/gi, "")
      .replace(/\bHHO[-\w]+\b/gi, "")
      .replace(/\bSignature Design by Ashley\b/gi, "")
      .replace(/\bBenchcraft\b/gi, "")
      .replace(/\bMillennium by Ashley\b/gi, "")
      .replace(/\bSolid Wood\b/gi, "")
      .replace(/\bTeak Wood\b/gi, "Teak")
      .replace(/\bWood Accent Piece\b/gi, "Accent Piece")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase()
      .replace(/\b([a-z])/g, (match) => match.toUpperCase())
      .replace(/\bPc\b/g, "Pc.")
      .replace(/\bUsb\b/g, "USB")
      .replace(/\bLed\b/g, "LED")
      .replace(/\bTv\b/g, "TV")
      .replace(/\bSofa\/Chaise\b/g, "Sofa/Chaise");
    return cleaned
      .replace(/\bLive Edge\b/g, "Live Edge")
      .replace(/\bUsb\b/g, "USB")
      .replace(/\bLed\b/g, "LED")
      .replace(/\bTv\b/g, "TV")
      .trim();
  }

  function enhanceVariantSelector(selector) {
    const variants = parseVariants(selector);
    if (!variants.length) return;

    const panel = selector.closest(".ashley-product-panel");
    const page = selector.closest(".shopify-product-page") || document;
    const form = page.querySelector(".product-form");
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    const submit = form ? form.querySelector('button[type="submit"]') : null;
    const price = page.querySelector("[data-variant-price]");
    const monthly = page.querySelector("[data-variant-monthly]");
    const sku = page.querySelector("[data-variant-sku]");
    const model = page.querySelector("[data-variant-model]");
    const availability = page.querySelector("[data-variant-availability]");
    const browseSku = page.querySelector("[data-browse-sku]");
    const summary = selector.querySelector("[data-variant-summary]");
    const selectedTitle = panel ? panel.querySelector("[data-selected-variant-title]") : null;
    const subtitleVariant = panel ? panel.querySelector("[data-product-subtitle-variant]") : null;
    const piecePicker = page.querySelector("[data-ashley-piece-picker]");
    const mainImage = page.querySelector(".select-product-main img");

    const applyVariant = (variant) => {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (monthly) monthly.textContent = `Approx. ${formatMoney(variant.price / 12)}/mo for 12 months* before taxes and fees`;
      if (sku) sku.textContent = variant.sku || "";
      if (model) model.textContent = variant.sku || "";
      if (availability) availability.textContent = variant.available ? "Available to order" : "Ask showroom";
      if (browseSku) browseSku.textContent = variant.sku || "";
      if (summary) summary.textContent = variant.title;
      if (selectedTitle) selectedTitle.textContent = variant.title;
      if (subtitleVariant) subtitleVariant.textContent = variant.title;
      if (piecePicker) piecePicker.dataset.productSku = variant.sku || "";
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? "Add to cart" : "Contact showroom";
      }
      const featuredImage = imageUrl(variant);
      if (featuredImage && mainImage) {
        mainImage.src = featuredImage;
        mainImage.alt = variant.title;
      }
      window.dispatchEvent(new CustomEvent("heft:variant-price-change", {
        detail: {
          sku: variant.sku || "",
          title: variant.title || "",
          price: formatMoney(variant.price)
        }
      }));
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    };

    const syncVisualOptions = () => {
      selector.querySelectorAll("select[data-option-position]").forEach((select) => {
        const position = select.dataset.optionPosition;
        const display = selector.querySelector(`[data-option-display="${position}"]`);
        if (display) display.textContent = select.value;
        selector.querySelectorAll(`[data-visual-option-value][data-option-position="${position}"]`).forEach((button) => {
          const isSelected = button.dataset.visualOptionValue === select.value;
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        });
      });
    };

    selector.querySelectorAll("[data-visual-option-value]").forEach((button) => {
      button.addEventListener("click", () => {
        const select = selector.querySelector(`select[data-option-position="${button.dataset.optionPosition}"]`);
        if (!select) return;
        select.value = button.dataset.visualOptionValue;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    selector.querySelectorAll("[data-option-position]").forEach((select) => {
      if (select.tagName !== "SELECT") return;
      select.addEventListener("change", () => {
        syncVisualOptions();
        const variant = variants.find((item) => variantMatches(item, selectedOptions(selector)));
        applyVariant(variant);
      });
    });

    syncVisualOptions();
    applyVariant(variants.find((item) => variantMatches(item, selectedOptions(selector))));
  }

  function enhanceGallery(gallery) {
    const mainImage = gallery.querySelector(".select-product-main img");
    const thumbs = Array.from(gallery.querySelectorAll(".select-product-thumbs figure"));
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb, index) => {
      const image = thumb.querySelector("img");
      if (!image) return;
      thumb.setAttribute("tabindex", "0");
      thumb.setAttribute("role", "button");
      thumb.setAttribute("aria-label", `View image ${index + 1}`);
      if (index === 0) thumb.classList.add("is-active");

      const showImage = () => {
        mainImage.src = image.src;
        mainImage.alt = image.alt || mainImage.alt;
        thumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
        thumb.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      };

      thumb.addEventListener("click", showImage);
      thumb.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          showImage();
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-product-display-title], .select-product-page:not(.shopify-product-page) .select-product-info h1").forEach((element) => {
      element.textContent = toDisplayTitle(element.textContent);
    });
    document.querySelectorAll(".select-product-page:not(.shopify-product-page) .select-product-info > p").forEach((element) => {
      const title = element.closest(".select-product-info")?.querySelector("h1")?.textContent?.trim() || "This piece";
      const isOriginal = /originals/i.test(element.textContent);
      element.textContent = `${title} is ${isOriginal ? "a HEFT Home Originals piece" : "part of HEFT Home Select"} chosen for proportion, finish, and room presence. Visit Bowmanville to confirm availability, pricing, delivery, financing, and how it fits your space.`;
    });
    document.querySelectorAll("[data-product-variants]").forEach(enhanceVariantSelector);
    document.querySelectorAll(".select-product-gallery").forEach(enhanceGallery);
    document.querySelectorAll("[data-copy-product-link]").forEach((button) => {
      button.addEventListener("click", async () => {
        const value = button.dataset.copyValue || window.location.href;
        try {
          await navigator.clipboard.writeText(value);
          button.textContent = "Copied";
          window.setTimeout(() => {
            button.textContent = "Copy product link";
          }, 1800);
        } catch (error) {
          window.prompt("Copy product link", value);
        }
      });
    });
  });
})();
